import { createContext } from "react";

export type SessionOverlayState = {
  screen: "closed" | "sign-in" | "sign-up" | "try-sign-in";
  state?: {
    email: string;
  };
};

export const SessionOverlayContext = createContext<{
  sessionOverlayState: SessionOverlayState;
  setSessionOverlayState: (state: SessionOverlayState) => void;
}>({} as any);
